module.exports = __webpack_public_path__ + "img/C536.124e8f54.jpg";